const AUTH_PADEN = ['/callback', '/silent_renew'];

// Waar de app heen moet als deze host in `redirects` van de portaalinstellingen
// staat, of null als hij hier mag blijven.
//
// Op /callback en /silent_renew niet naar hetzelfde pad (#7364). De inlogrespons
// staat in de hash, en die gaat niet mee; ook mét de hash zou het niet werken,
// want de oidc-state staat in de sessionStorage van deze origin. Op de nieuwe
// host bleef de app dan op /callback zonder respons staan. Op `/` begint daar een
// gewone login, die met een SSO-sessie meteen terugkomt.
export function domainRedirectUrl(redirects, location) {
    if (!redirects) return null;

    const current = location.hostname.toLowerCase();
    const hostFrom = Object.keys(redirects).find((host) => host.toLowerCase() === current);
    const hostTo = hostFrom && redirects[hostFrom];

    if (!hostTo) return null;

    const pad = AUTH_PADEN.some((authPad) => location.pathname.startsWith(authPad))
        ? '/'
        : `${location.pathname}${location.search}`;

    return `${location.protocol}//${hostTo}${pad}`;
}
